const URL = {
  HEADLESS_GOOGLE_DRIVE_AUTH_URL: 'collection-builder/google-drive/auth-url',
  HEADLESS_GOOGLE_DRIVE_STATUS: 'collection-builder/google-drive/status',
  HEADLESS_GOOGLE_DRIVE_FOLDERS: 'collection-builder/google-drive/folders',
  HEADLESS_GOOGLE_DRIVE_FILES: 'collection-builder/google-drive/files',
  HEADLESS_GOOGLE_DRIVE_PLAN: 'collection-builder/google-drive/plan',
  HEADLESS_GOOGLE_DRIVE_DISCONNECT: 'collection-builder/google-drive/disconnect',
  HEADLESS_STORE_API_KEY: 'collection-builder/settings/api-keys',
  HEADLESS_API_KEY_STATUS: 'collection-builder/settings/api-keys/status',
  HEADLESS_DELETE_API_KEY: 'collection-builder/settings/api-keys',
  HEADLESS_HEYGEN_CREDITS: 'collection-builder/settings/heygen/credits',
  HEADLESS_PROMPTS: 'collection-builder/settings/prompts',
  HEADLESS_PROCESS_DOCUMENTS: 'collection-builder/process-documents',
  HEADLESS_ANALYZE: 'collection-builder/analyze',
  HEADLESS_GENERATE: 'collection-builder/generate',
  HEADLESS_SESSIONS: 'collection-builder/sessions',
  HEADLESS_CB_SETTINGS: 'collection-builder/settings/collection-builder',
}

export default URL
